import React, { useContext, useEffect } from "react";
import PmoTooltip from "../../../ProductMarketingOptimization/components/common/PmoTooltip";
import CompetitorSelect from "../competitorSelect";
import { RouteComponentProps, withRouter } from "react-router-dom";
import BrandImageSnapshotChart from "../../../../components/Charts/BrandPerformance/BrandImageSnapshotChart";
import { ThemeContext } from "../../../../context";
import { getImageSnapshotsBrandImageAttributes } from "../../../../api/brandPerformanceApi";
import { useQuery } from "@tanstack/react-query";
import { RootStateOrAny, useSelector } from "react-redux";
import { ErrorBoundary } from "@sentry/react";
import { ErrorMsg, NoDataMsg } from "../../../../components/AppMessages";
import LoadingEllipsis from "../../../../components/Loading/LoadingEllipsis";

interface Props extends RouteComponentProps {
  onHandleRadioClick: any;
  nissanCompetitor: string;
  diff: number;
  isFetchingFilter: boolean;
  granularity: string;
}

const ImageSnapshotContent = withRouter((props: Props) => {
  const { diff, nissanCompetitor, onHandleRadioClick, history, isFetchingFilter, granularity } = props;

  const { theme } = useContext(ThemeContext);

  const params = useSelector((state: RootStateOrAny) => state.parameters);

  // fetch data
  const {
    data: imageSnapshotsBrandImageAttributesData,
    isFetching: isFetchingImageSnapshotsBrandImageAttributesData,
    refetch: refetchImageSnapshotsBrandImageAttributesData,
  } = useQuery(
    ["imageSnapshotsBrandImageAttributesData", granularity, history.location.search],
    () => getImageSnapshotsBrandImageAttributes({ ...params, nissan_competitor: nissanCompetitor }),
    { enabled: false }
  );

  // when the url changes, refetch the data
  useEffect(() => {
    refetchImageSnapshotsBrandImageAttributesData();
  }, [history.location.search]);

  return (
    <div className="brand-image-snapshot primary_background ">
      <div className="header" style={{ paddingTop: "1em", paddingLeft: "1em" }}>
        <div className="title_container">
          <>
            <h3>Brand Image Snapshot</h3>
          </>
          {nissanCompetitor && <CompetitorSelect onHandleRadioClick={onHandleRadioClick} nissanCompetitor={nissanCompetitor} />}
        </div>
      </div>
      <div className="chart_content">
        {imageSnapshotsBrandImageAttributesData?.data?.length && !isFetchingImageSnapshotsBrandImageAttributesData && !isFetchingFilter ? (
          <ErrorBoundary fallback={<ErrorMsg />}>
            <BrandImageSnapshotChart
              data={imageSnapshotsBrandImageAttributesData?.data ?? []}
              seriesList={imageSnapshotsBrandImageAttributesData?.series ?? []}
              chartId="brandSnapshotChart"
              isLoading={isFetchingImageSnapshotsBrandImageAttributesData}
              theme={theme}
              percentageChart={true}
            />{" "}
          </ErrorBoundary>
        ) : isFetchingImageSnapshotsBrandImageAttributesData ? (
          <LoadingEllipsis isLoading={isFetchingImageSnapshotsBrandImageAttributesData} />
        ) : (
          <NoDataMsg message="No data available" />
        )}
      </div>
    </div>
  );
});

export default ImageSnapshotContent;
